import { useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

const regex = /^(?:[a-z-]+|\d+)$/i;

export const useGetClassIfActive = (path: string | string[]): string | undefined => {
  const location = useLocation();

  const hasActive = useMemo(() => {
    return isPathActive(path, location.pathname);
  }, [path, location.pathname]);

  return hasActive ? 'active' : undefined;
};

export const isPathActive = (path: string | string[], pathname: string): boolean => {
  const paths = Array.isArray(path) ? path : [path];
  return paths.some((p) => {
    const match = matchPath(p, pathname);
    if (!match) return false;
    if (match.params.id && regex.test(match.params.id)) {
      const parentPath = p.split('/:')[0];
      return pathname.startsWith(parentPath);
    }
    return true;
  });
};
